import { Spinner } from '@/components/shared';
import React, { Suspense, lazy, useEffect, useState, type ComponentType, type FC } from 'react';
import { IViewResolverComponentProps } from 'Components/view-resolver/view-resolver.interface';

// @ts-ignore: federated module

const MyBagPage: FC<IViewResolverComponentProps> = () => {
  const [MyBag, setMyBag] = useState<ComponentType<any> | null>(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      setMyBag(lazy(() => import('beautyFrontendPlp/MyBag')));
    }
  }, []);
  return (
    <>
      <Suspense fallback={<Spinner />}>{MyBag ? <MyBag /> : null}</Suspense>
    </>
  );
};

export default MyBagPage;
